
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/annual-conference-attendees-list",
      function () {
        return require("private-next-pages/events/annual-conference-attendees-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/annual-conference-attendees-list"])
      });
    }
  